/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import { pageSubtitleCss } from '../../../lib/styles/typography'

type PageSubtitleProps = {
  /** Text to render as a subtitle */
  subtitle: string
  /** Aligns subtitle to the left */
  pullLeft?: boolean
}

const defaultProps: Pick<PageSubtitleProps, 'pullLeft'> = {
  pullLeft: false
}

const pullSubtitleLeftCss = css`
  ${pageSubtitleCss}
  text-align: left;
`

const PageSubtitle = ({ subtitle, pullLeft }: PageSubtitleProps) =>
  pullLeft ? (
    <div css={pullSubtitleLeftCss}>{subtitle}</div>
  ) : (
    <div css={pageSubtitleCss}>{subtitle}</div>
  )

PageSubtitle.defaultProps = defaultProps

export default PageSubtitle
